// Missouri S&T's undergraduate majors (#2652). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog's Degree Programs page
// (catalog.mst.edu), which lists every degree program in capitals with its
// degree (BS, BA) and its emphasis areas below it: every degree program
// kept, emphasis areas, minors, certificates and graduate programs left
// out. The catalog's "Program Updates Since Publication in August" page
// lists no new programs. The catalog's list is not grouped by college, so
// the majors here are one group. A program offered as both a BA and a BS
// appears once for each degree. Names are the catalog's, set in title case
// (the catalog prints them in capitals). The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    "slug": "missouri-university-of-science-and-technology",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in Missouri S&T's official 2026-2027 Undergraduate Catalog, with the degree it leads to. Emphasis areas, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Degree programs, 2026-2027 Undergraduate Catalog",
            "source": {
                "label": "Missouri S&T 2026-2027 Undergraduate Catalog, Degree Programs",
                "url": "https://catalog.mst.edu/undergraduate/degreeprogramsandcourses/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Business and Management Systems",
                    "degree": "BS"
                },
                {
                    "name": "Ceramic Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Education",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Management",
                    "degree": "BS"
                },
                {
                    "name": "English and Technical Communication",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Geological Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Geology and Geophysics",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BS"
                },
                {
                    "name": "Information Science & Technology",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Metallurgical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mining Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Multidisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Nuclear Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Petroleum Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Psychological Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychological Science",
                    "degree": "BS"
                },
                {
                    "name": "Semiconductor Engineering",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
